<div class="modal-backdrop">
  <div class="modal-container">
    <div class="modal">
      <div class="modal-header">
        <h3 class="modal-title">{{ isEditMode ? 'Editar' : 'Criar' }} Pagamento</h3>
      </div>

      <mat-dialog-content class="modal-body">
        <form [formGroup]="paymentForm" class="payment-form">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>ID do Plano de Acesso</mat-label>
            <input matInput type="number" formControlName="accessPlanId" required>
            <mat-error *ngIf="paymentForm.get('accessPlanId')?.hasError('required')">
              ID do plano é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>CPF/CNPJ do Plano</mat-label>
            <input matInput formControlName="planCpfcnpj">
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Valor Total</mat-label>
            <input matInput type="number" formControlName="totalAmount" min="0.01" step="0.01" required>
            <span matPrefix>R$&nbsp;</span>
            <mat-error *ngIf="paymentForm.get('totalAmount')?.hasError('required')">
              Valor é obrigatório
            </mat-error>
            <mat-error *ngIf="paymentForm.get('totalAmount')?.hasError('min')">
              Valor deve ser maior que zero
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Número de Parcelas</mat-label>
            <input matInput type="number" formControlName="numberOfInstallments" min="1" required>
            <mat-error *ngIf="paymentForm.get('numberOfInstallments')?.hasError('required')">
              Número de parcelas é obrigatório
            </mat-error>
            <mat-error *ngIf="paymentForm.get('numberOfInstallments')?.hasError('min')">
              Deve ter pelo menos 1 parcela
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Método de Pagamento</mat-label>
            <mat-select formControlName="method" required>
              <mat-option *ngFor="let method of paymentMethods" [value]="method">
                {{ method | enumDescription }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="paymentForm.get('method')?.hasError('required')">
              Método de pagamento é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" required>
              <mat-option *ngFor="let status of paymentStatus" [value]="status">
                {{ status | enumDescription }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="paymentForm.get('status')?.hasError('required')">
              Status é obrigatório
            </mat-error>
          </mat-form-field>
        </form>
      </mat-dialog-content>

      <mat-dialog-actions class="modal-footer">
        <button mat-stroked-button (click)="onCancel()" class="btn btn-ghost">
          <mat-icon>close</mat-icon>
          Cancelar
        </button>
        <button mat-flat-button color="primary" (click)="onSave()" [disabled]="paymentForm.invalid" class="btn btn-primary">
          <mat-icon>save</mat-icon>
          {{ isEditMode ? 'Atualizar' : 'Criar' }}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
